import { render, staticRenderFns } from "./SyncItemMaster.vue?vue&type=template&id=664f822b&scoped=true&"
import script from "./SyncItemMaster.vue?vue&type=script&lang=js&"
export * from "./SyncItemMaster.vue?vue&type=script&lang=js&"
import style0 from "./SyncItemMaster.vue?vue&type=style&index=0&id=664f822b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664f822b",
  null
  
)

export default component.exports